import { render, staticRenderFns } from "./IndexShipmentlLeaderWinChange.vue?vue&type=template&id=56b1b68c&scoped=true&"
import script from "./IndexShipmentlLeaderWinChange.vue?vue&type=script&lang=js&"
export * from "./IndexShipmentlLeaderWinChange.vue?vue&type=script&lang=js&"
import style0 from "./IndexShipmentlLeaderWinChange.vue?vue&type=style&index=0&id=56b1b68c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b1b68c",
  null
  
)

export default component.exports